import type {PropsWithClassName} from 'types/util'
import {cn} from 'utils'

export function InlineSpinner({
  mode = 'dark',
  className,
}: {mode?: 'light' | 'dark'} & PropsWithClassName) {
  return (
    <div
      className={cn('w-4 h-4 bg-transparent relative inline-block', className)}
    >
      <div
        className={cn(
          'w-4 h-4 rounded-[50px] animate-spin',
          mode === 'light'
            ? 'shadow-smallSpinnerLight'
            : 'shadow-smallSpinnerDark'
        )}
      />
    </div>
  )
}
